import { render } from "./matching-empty-results.vue?vue&type=template&id=2ec08545&ts=true"
import script from "./matching-empty-results.vue?vue&type=script&lang=ts"
export * from "./matching-empty-results.vue?vue&type=script&lang=ts"

import "./matching-empty-results.vue?vue&type=style&index=0&id=2ec08545&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__